import { render, staticRenderFns } from "./myAffair.vue?vue&type=template&id=ac28d484&scoped=true&"
import script from "./myAffair.vue?vue&type=script&lang=js&"
export * from "./myAffair.vue?vue&type=script&lang=js&"
import style0 from "./myAffair.vue?vue&type=style&index=0&id=ac28d484&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac28d484",
  null
  
)

export default component.exports